export const FUNCTIONAL_ERROR = "functional_error";
export const SERVER_ERROR = "server_error";
export const NOT_FOUND_ERROR = "not_found_error";
export function getErrorType(error: any) {
    if (error?.status == 404) {
        return NOT_FOUND_ERROR;
    } else if (error?.status >= 400 && error?.status < 500) {
        return FUNCTIONAL_ERROR;
    } else {
        return SERVER_ERROR;
    }
}

// message sent by the backend for client errors (4xx), undefined for server errors or when no message was sent
export function handleErrors(err: any): string | undefined {
    if (getErrorType(err) == SERVER_ERROR) {
        return undefined;
    }
    return extractMessage(err?.error);
}

export function getErrorMessage(err: any, fallbackMessage: string): string {
    return handleErrors(err) ?? fallbackMessage;
}

function extractMessage(payload: any): string | undefined {
    if (typeof payload === 'string') {
        try {
            return extractMessage(JSON.parse(payload));
        } catch {
            return undefined;
        }
    }
    const message = payload?.message;
    if (typeof message === 'string' && message.trim().length > 0) {
        return message;
    }
    return undefined;
}
